import React, { useEffect } from "react";
import ArticulationSideView from "./ArticulationSideView";

export default function ArticulationModal({ open, onClose, target }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[90]">
      <div
        className="absolute inset-0 bg-black/40 backdrop-blur-sm"
        onClick={onClose}
        aria-hidden="true"
      />

      {/* ✅ Top-aligned container (instead of centered) */}
      <div className="absolute inset-x-0 top-6 flex justify-center px-3 sm:px-6">
        <div className="w-[min(96vw,1100px)]">
          <div className="max-h-[92vh] overflow-hidden rounded-2xl border bg-white shadow-2xl">
            {/* Header */}
            <div className="flex items-center justify-between border-b px-4 py-3">
              <div className="text-sm font-semibold text-slate-900">
                Articulation (large)
              </div>
              <button
                type="button"
                onClick={onClose}
                className="rounded-xl border bg-white px-3 py-2 text-xs font-semibold text-slate-800 hover:bg-slate-50"
              >
                Close
              </button>
            </div>

            {/* Body (scroll-safe) */}
            <div className="max-h-[calc(92vh-56px)] overflow-auto p-4">
              <ArticulationSideView
                target={target}
                size="large"
                align="top"
                enableModalClick={false}
                onOpenModal={null}
                showControls={true} // ✅ NEW
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}